<div class="card">
  <div class="card-body">
    <form [formGroup]="searchForm" (ngSubmit)="onSearch()" class="row">
      <div class="form-group col-lg-3 col-md-4 col-xs-12">
        <label>{{resources.AllocationScaniaUnit}}:</label>
        <div class="scania-unit-select-wrap">
          <mat-form-field class="scania-unit-select-field" appearance="outline">
            <mat-select formControlName="selectedScaniaUnitIds" multiple disableOptionCentering>
              <mat-select-trigger>
                <div class="selected-scania-chip-list" *ngIf="getSelectedScaniaUnits().length; else emptyScaniaSelection">
                  <span class="selected-scania-chip" *ngFor="let selected of getSelectedScaniaUnits()">
                    <span class="selected-scania-chip-label">{{ selected.name }}</span>
                    <button type="button"
                            class="selected-scania-chip-remove"
                            [attr.aria-label]="'Remove ' + selected.name"
                            (mousedown)="onChipActionMouseDown($event); removeSelectedScaniaUnit(selected.id)"
                            (click)="onChipActionMouseDown($event)">&times;</button>
                  </span>
                  <button type="button"
                          class="btn btn-primary clear-scania-unit-chip"
                          aria-label="Clear selection"
                          (mousedown)="onChipActionMouseDown($event); clearSelectedScaniaUnits()"
                          (click)="onChipActionMouseDown($event)">Clear all</button>
                </div>
                <ng-template #emptyScaniaSelection>
                  <span>Select unit(s)</span>
                </ng-template>
              </mat-select-trigger>
              <mat-option [value]="-1">*{{resources.All}}*</mat-option>
              <mat-option *ngFor="let scaniaUnit of scaniaUnitList | async" [value]="scaniaUnit.id">
                {{scaniaUnit.name}} - {{scaniaUnit.description}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
        <div class="form-group col-lg-4 col-md-6 col-xs-12">
          <label>{{resources.FlowStartFrom}} - {{resources.FlowStartTo}}:</label>
          <mat-form-field class="flow-date-range-field" appearance="outline">
            <mat-date-range-input [formGroup]="searchForm" [rangePicker]="flowDateRangePicker">
              <input matStartDate formControlName="startDate" placeholder="yyyy-mm-dd" />
              <input matEndDate formControlName="endDate" placeholder="yyyy-mm-dd" />
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="flowDateRangePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #flowDateRangePicker></mat-date-range-picker>
          </mat-form-field>
        </div>
        <div class="form-group col-md-1 col-xs-12">
          <label>&nbsp;</label>
          <button class="btn btn-primary form-control" type="submit">
            {{resources.Search}}
          </button>
        </div>
    </form>
  </div>
</div>
<p></p>
<cal-calsiumlist-listing [config]="listConfig" [ListBodyData]="dataList | async" (sortTriggered)="onSort($event)"
  (filterTriggered)="onFilter($event)" [filterExpression]="filterExpression | async" (clearFilterAndSortingTriggered)="onClearFilterAndSorting()" [isLoading]="isLoading | async"
  (exportToExcelTriggered)="onExportToExcel()"
  [dataTotalCount]="totalCount | async">
</cal-calsiumlist-listing>
<cal-pagination [paging]="paging | async" (pageChange)="onPaging($event)" [dataTotalCount]="totalCount | async">
</cal-pagination>